<template>
  <b-container fluid>
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12">
        <div class="card mb-3">
          <div class="card-body">
            <!--@Todo: component-->
            <div class="row">
              <div class="col-md-2 m-auto">
                <select-field
                    v-model="perPage"
                    property="per-page-select"
                    name="Nombre de pages"
                    :options="pageOptions"
                />
              </div>
              <div class="col-md-6 m-auto">
                <text-button-field
                    v-model="filter"
                    property="filter"
                    name="Type de recherche"
                    :disabled="!filter"
                />
              </div>
              <div class="col-md-4 m-auto">
                <checkbox-field
                    class="mt-1"
                    v-model="filterOn"
                    property="filterOn"
                    name="Filtrer"
                    :options="filters"
                    index="value"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-12 col-md-12 col-sm-12">
        <div class="card">
          <div class="card-body">
            <!-- Main table element -->
            <div class="row">
              <div class="col-md-12">
                <b-table
                    :items="clients"
                    :fields="fields"
                    :current-page="currentPage"
                    :per-page="perPage"
                    :filter="filter"
                    :filter-included-fields="filterOn"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    :sort-direction="sortDirection"
                    stacked="sm"
                    :busy="!apiRslt.fetch.success"
                    show-empty
                    responsive
                    @filtered="onFiltered"
                >
                  <template #cell(actions)="row">
                    <a class="btn btn-light mr-1 text-center" style="cursor:pointer;" @click="info(row.item, row.index, $event.target)" >
                      <i class="fa fa-user" aria-hidden="true"></i>
                    </a>
                  </template>
                </b-table>
                <div class="mb-2 text-end">
                  Nombre total: <b>{{ clients.length }} élement(s)</b>
                </div>
              </div>

              <div class="col-md-12 m-auto">
                <b-pagination
                    v-model="currentPage"
                    :total-rows="clients.length"
                    :per-page="perPage"
                    pills
                    class="my-0 justify-content-center"
                ></b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>



    <!-- Info modal -->
    <b-modal :id="infoModal.id" size="lg" hide-footer>
      <template #modal-title>
        &nbsp;
      </template>
      <div class="row" v-if="typeof infoModal !== 'string'">
        <h5 class="text-muted my-4">Informations client</h5>
        
        <div class="d-flex w-100 justify-content-between my-3">
          <h5 class="mb-1">{{ infoModal.content.firstname }} {{ infoModal.content.lastname }}</h5>
          <small v-if="infoModal.content.orders">{{ infoModal.content.orders.length }} commande(s)</small>
        </div>
        <p class="mb-1">{{ infoModal.content.phone }}</p>
        <small>{{ infoModal.content.email }}</small>
        
        
        <h5 class="text-muted my-4">Chronologie</h5>
        <timeline :items="infoModal.content.orders">
          <template v-slot:content="row">
            <time class="cbp_tmtime" :datetime="row.row.createdAt">
              {{ row.row.createdAt | hourFormat }}<br>
              <small>{{ row.row.createdAt | interval }}</small>
            </time>

            <state-icon-tag :state="row.row.state"/>

            <div class="cbp_tmlabel">

              <h5 class="text-muted font-weight-bold">
                Référence #{{ row.row.reference }}
                <paiement-tag :payment="row.row.statusPaid" />
              </h5>

              <div class="row">
                <div class="col-md-12 my-2">
                  <span class="text-muted">Date:</span>  {{ row.row.createdAt | formatDateShort }}
                </div>
                <div class="col-md-12 my-2">
                  <span class="text-muted">Total: </span>
                  {{ row.row.total | numberWithCommas }}
                </div>
                <div class="col-md-12 my-2">
                  <span class="text-muted">Livraison: </span>
                  <span v-if="row.row.deliverMode === 0">Récupérer le plus tôt possible</span>
                  <span v-if="row.row.deliverMode === 1">
                    Récupérer plus tard: {{ row.row.deliverDate }}
                  </span>
                </div>
                <div class="col-md-12 my-2" v-show="row.row.pointVente">
                  <span class="text-muted">Référence point de collecte: </span>
                  {{ row.row.pointVente }}
                </div>
              </div>

              <div class="d-flex justify-content-end mt-3">
                <b-button v-b-toggle="'collapse-2' + row.row.id + 'comment'" class="mb-2 mr-2" size="sm" variant="light">Commentaire</b-button>
                <b-button v-b-toggle="'collapse-2' + row.row.id" class="mb-2" size="sm" variant="light">Détails</b-button>
              </div>
              <b-collapse :id="'collapse-2' + row.row.id + 'comment'" >
                <textarea-field
                    name="Commentaire"
                    property="comment"
                    length="75"
                    v-model="row.row.comment"
                    :disabled="true"
                />
              </b-collapse>
              <b-collapse :id="'collapse-2' + row.row.id" >
                <ul class="list-group">
                  <li v-for="item in row.row.orderItems" :key="item.id"
                      class="list-group-item d-flex justify-content-between align-items-start">
                    <div class="ms-2 me-auto">
                      <div class="fw-bold">
                        {{ item.name }}
                        <span class="badge bg-primary rounded-pill">x {{ item.qty }}</span>
                      </div>
                      <span class="text-capitalize">{{ item.category }}</span>
                    </div>
                    <div class="ms-2 me-auto" v-if="item.category === 'menu'">
                      <span class="small" v-for="product in item.products" :key="product.name">
                        <i>{{ product.cat }} </i>
                        <b>{{ product.name }} </b>
                        x {{ product.qty }} <br>
                      </span>
                    </div>
                    <span class="badge bg-primary rounded-pill">{{ item.price | numberWithCommas }}</span>
                  </li>
                </ul>
              </b-collapse>
            </div>
          </template>
        </timeline>
      </div>
    </b-modal>


  </b-container>
</template>

<script>
import {mapState, mapActions } from "vuex";
import Timeline from "@/core/components/Timeline";
import {TextareaField} from "@/core/components/form";
import {table} from "@/core/mixins";
import PaiementTag from "@/modules/order/components/PaiementTag";
import StateIconTag from "@/modules/order/components/StateIconTag";

export default {
  name: 'Clients',
  components:{
    Timeline,
    TextareaField,
    PaiementTag,
    StateIconTag
  },
  mixins:[table],
  data(){
    return {
      fields:[
        { key: 'lastname', label: 'Nom client', sortable: true },
        { key: 'email', label: 'Email', sortable: true },
        { key: 'phone', label: 'Téléphone', sortable: true },
        { key: 'actions', label: 'Actions' }
      ],
      filters:[
        { text: 'Nom', value:'lastname' },
        { text: 'Email', value: 'email' },
        { text: 'Téléphone', value: 'phone'}
      ]
    }
  },
  computed: {
    ...mapState('clients',['clients','apiRslt'])
  },
  created() {
    this.loadClients()
  },
  methods: {
    ...mapActions('clients', ['loadClients'])
  },
}
</script>
<style>
  .modal {
    top: 5rem;
    z-index: 9999;
}
</style>
